import React from 'react';
import IconCheckmarkCircle from '../ui/icons/IconCheckmarkCircle';
import useSearchCities from './hooks/useSearchCities';
import { useSearchStateLocation, useSearchStateLocationDispatch } from './hooks/useSearchStateLocation';

const SearchFiltersCities = ( props ) => {
	const { submarket, cities: citiesInState, stateAsLocation } = useSearchStateLocation();

	const dispatch = useSearchStateLocationDispatch();
	const { data, currentCities, isLoading, isError } = useSearchCities( { submarket, stateAsLocation } );

	const handleChange = ( city ) => {
		const type = citiesInState.includes( city ) ? 'removeCity' : 'addCity';
		dispatch( {
			type,
			city,
		} );
	};

	if ( currentCities === null ) {
		return <div>No cities found</div>;
	}

	if ( isLoading || data.states.length === 0 || currentCities.length === 0 ) {
		return null;
	}

	return (
		<div className="tw-flex tw-flex-col tw-flex-wrap">
			<ul className="tw-list-none tw-pl-0 tw-flex tw-flex-wrap tw-mb-0">
				{currentCities.map( ( city ) => {
					const isRefined = citiesInState.includes( city.name );
					return (
						<li key={city}>
							<div>
								<label className={`${ isRefined ? 'tw-bg-apple' : 'tw-bg-platinum hover:tw-bg-steel' } tw-items-center tw-flex tw-uppercase tw-tracking-wide tw-cursor-pointer tw-px-3 tw-mb-2 lg:tw-mb-4 tw-py-2 tw-mr-2 lg:tw-mr-4 tw-font-bold tw-text-xxxs tw-text-charcoal`}>
									{isRefined && (
										<span className="tw-mr-1">
											<IconCheckmarkCircle />
										</span>
									)}
									{city.name}
									<input className="tw-hidden" type="checkbox" checked={isRefined} onChange={() => handleChange( city.name )} />
								</label>
							</div>
						</li>
					);
				} )}
			</ul>
		</div>
	);
};

export default SearchFiltersCities;
